import { ComponentRef, Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { startWith, takeUntil } from 'rxjs/operators';
import { TasksListContextMenuComponent } from '../components/tasks-list-context-menu/tasks-list-context-menu.component';
import { TaskListStateService } from '../services/task-list-state.service';

@Directive({
  selector: '[appTasksListContextMenu]',
  standalone: false,
})
export class TasksListContextMenuDirective extends ContextMenuDirective implements OnInit, OnDestroy {
  @Input()
  public appTasksListContextMenuWithAdvancedSearch: boolean;
  @Input()
  public appTasksListContextMenuWithScore: boolean;
  @Input()
  public appTasksListContextMenuWithSidebarFilters = false;
  @Input()
  public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input()
  public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly taskListStateService = inject(TaskListStateService);

  /**
   * Context Menu Interface
   */

  protected override registerInstance(componentRef: ComponentRef<TasksListContextMenuComponent>) {
    componentRef.instance.state = this.taskListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appTasksListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appTasksListContextMenuWithScore;
    componentRef.instance.withSidebarFilters = this.appTasksListContextMenuWithSidebarFilters;
  }

  protected override registerComponent() {
    return TasksListContextMenuComponent;
  }

  /**
   * Lifecycle
   */

  public override ngOnInit() {
    super.ngOnInit();

    this.taskListStateService.state
      .changes()
      .pipe(startWith(null), takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.taskListStateService.state.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.taskListStateService.state.isDefault()) {
        this.taskListStateService.state.resetToDefault();
      }
    });
  }
}
